// Chakra imports
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Text,
  useColorMode,
  useColorModeValue
} from "@chakra-ui/react";
import pxq from "assets/img/pxq.png";
import pxqDark from "assets/img/pxqDark.png";
import useAuth from "hooks/useAuth";
import { useState } from "react";

function SignIn() {
  // Chakra color mode
  const titleColor = useColorModeValue("teal.300", "teal.200");
  const textColor = useColorModeValue("gray.400", "white");
  const { colorMode } = useColorMode()

  const { login } = useAuth()

  const [data, setData] = useState(null)

  const handleLogin = ({ target: { name, value } }) => {
    setData({
      ...data,
      [name]: value
    })
  }

  return (
    <Flex position='relative' mb='40px'>
      <Flex
        h={{ sm: "initial", md: "75vh", lg: "85vh" }}
        w='100%'
        maxW='1044px'
        mx='auto'
        justifyContent='space-between'
        mb='30px'
        pt={{ sm: "100px", md: "0px" }}>
        <Flex
          alignItems='center'
          justifyContent='start'
          style={{ userSelect: "none" }}
          w={{ base: "100%", md: "50%", lg: "42%" }}>
          <Flex
            direction='column'
            w='100%'
            background='transparent'
            p='48px'
            mt={{ md: "150px", lg: "80px" }}>
            <Heading color={titleColor} fontSize='32px' mb='10px'>
              Bienvenido
            </Heading>
            <Text
              mb='36px'
              ms='4px'
              color={textColor}
              fontWeight='bold'
              fontSize='14px'>
              Ingresá email y contraseña
            </Text>
            <FormControl>
              <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                Email
              </FormLabel>
              <Input
                data-testid="email"
                borderRadius='15px'
                mb='24px'
                fontSize='sm'
                type='text'
                placeholder='Tu email'
                size='lg'
                name="email"
                onChange={handleLogin}
              />
              <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                Contraseña
              </FormLabel>
              <Input
                data-testid="password"
                borderRadius='15px'
                mb='36px'
                fontSize='sm'
                type='password'
                placeholder='Tu contraseña'
                size='lg'
                name="password"
                onChange={handleLogin}
              />
              <Button
                data-testid="login-action"
                fontSize='10px'
                type='submit'
                bg='teal.300'
                w='100%'
                h='45'
                mb='20px'
                color='white'
                mt='20px'
                onClick={() => login(data)}
                _hover={{
                  bg: "teal.200",
                }}
                _active={{
                  bg: "teal.400",
                }}>
                Ingresar
              </Button>
            </FormControl>
          </Flex>
        </Flex>
        <Box
          bgImage={colorMode === "light" ? pxq : pxqDark}
          w='40%'
          h='40%'
          right="10%"
          top="33%"
          bgSize='cover'
          bgPosition='50%'
          position='absolute'
          borderBottomLeftRadius='20px'></Box>
      </Flex>
    </Flex>
  );
}

export default SignIn;
